import { Button, Dialog, Flex, Text } from '@radix-ui/themes';

type TransactionConfirmDialogProps = {
   title: string;
   message: string;
   loading?: boolean;
   confirmLabel: string;
   confirmColor?: 'green' | 'red' | 'blue';
   onConfirm: () => void;
};

export const TransactionConfirmDialog = ({
   title,
   message,
   loading = false,
   confirmLabel,
   confirmColor = 'blue',
   onConfirm,
}: TransactionConfirmDialogProps) => (
   <Flex direction="column" gap="4">
      <Dialog.Title>{title}</Dialog.Title>
      <Text>{message}</Text>
      <Flex justify="end" gap="3">
         <Dialog.Close>
            <Button variant="soft" color="gray" disabled={loading}>
               Cancel
            </Button>
         </Dialog.Close>
         <Button color={confirmColor} loading={loading} onClick={onConfirm}>
            {confirmLabel}
         </Button>
      </Flex>
   </Flex>
);
